import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "map-elem-info land-ai-detections" }
const _hoisted_2 = { class: "col-info" }
const _hoisted_3 = { class: "row1 mb6" }
const _hoisted_4 = { class: "left-side" }
const _hoisted_5 = { class: "ft-bold mb6" }
const _hoisted_6 = { class: "ib val" }
const _hoisted_7 = { class: "kp-info-disp mb6" }
const _hoisted_8 = { class: "ib lbl" }
const _hoisted_9 = { class: "angle-disp ml16" }
const _hoisted_10 = { class: "ib mr2" }
const _hoisted_11 = { class: "angle-arrow-wrap" }
const _hoisted_12 = { class: "mb6" }
const _hoisted_13 = { class: "ib val" }
const _hoisted_14 = { class: "ib val" }
const _hoisted_15 = { class: "ib val" }
const _hoisted_16 = {
  key: 0,
  class: "mb6"
}
const _hoisted_17 = { class: "ib val" }
const _hoisted_18 = { class: "image-preview-area" }
const _hoisted_19 = {
  key: 0,
  class: "image-box"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "right-side mr8" }
const _hoisted_22 = { class: "move-buttons mt2" }
const _hoisted_23 = { class: "row2" }
const _hoisted_24 = {
  key: 0,
  class: "buttons ta-right mr8"
}

import extLandAiDetectionsApi from 'src/apis/extLandAiDetections';
import {
  onMounted,
  watch,
  reactive,
  computed,
} from 'vue';
import type { MapElemInfo } from 'src/models';
import { validateAngle } from 'src/lib/commentHelper';
import useMapElemInfoImagePreview from 'src/composables/useMapElemInfoImagePreview';
import { dtFormat } from 'src/lib/dateHelper';
import type { GIDetection } from 'src/models/geoItem';

interface MapElemInfoLandAiDetectionsState {
  detection: GIDetection;
}

interface Props {
  elem: MapElemInfo<GIDetection>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MapElemInfoLandAiDetections',
  props: {
    elem: {}
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive<MapElemInfoLandAiDetectionsState>({
  detection: props.elem.data,
});
const dateDisp = computed<string>(() => dtFormat(new Date(state.detection.imgTs)));
const modalTitle = computed<string>(() => `${dateDisp.value} - ${kpDisp.value}`);
const downloadFilenameTemplate = computed<string>(() => {
  const detectionsTs = dtFormat(new Date(state.detection.imgTs), 'yyyymmddHHMMSS');
  return `${state.detection.detectionKindDisp}_${detectionsTs}_$TIMESTAMP.jpg`;
});
const skipFetchingImage = computed<boolean>(() => {
  return !state.detection?.imgPath;
});
const { showPrevious, showNext, savedImage, showImage } = useMapElemInfoImagePreview({
  emit,
  elem: computed(() => props.elem),
  refMapElemInfoData: computed(() => state.detection),
  skipFetchingImage,
  fetchApiFn: () => {
    return extLandAiDetectionsApi.getImage({
      img_path: state.detection.imgPath,
    });
  },
  modalTitle,
  downloadFilenameTemplate,
});

const initDisplay = () => {
  state.detection = props.elem.data;
};
onMounted(initDisplay);
watch(() => props.elem, initDisplay);

const getLocationDispOfKp = (): string => {
  // roadNameDispが空だったら「場所なし」と表示する
  const roadNameDisp = state.detection.roadNameDisp ? state.detection.roadNameDisp : '場所なし';
  // 全角のカッコが割と場所取るので半角に置換
  const placeName = !state.detection.placeName || state.detection.placeName === 'main_line'
    ? ''
    : state.detection.placeName
      .replace(/（/g, '(')
      .replace(/）/g, ')');
  // 小数第二位まで考慮
  const kpDisp = state.detection.kp
    ? `${parseFloat(state.detection.kp).toFixed(2).replace(/0$/, '')}km`
    : '';
  return [
    roadNameDisp,
    state.detection.direction,
    placeName,
    kpDisp,
  ].filter(e => !!e).join(' ');
};
const kpDisp = computed<string>(getLocationDispOfKp);
const iconPath = `/static/img/land_ai_detection_${state.detection.detectionKind}.png`;
const hasValidAngle = computed(() => {
  return validateAngle(state.detection.angle);
});
const detectionsLink = computed<string>(() => {
  if (state.detection.roadNameDisp) {
    return state.detection.detectionsLink;
  }
  // 場所なしの場合、遷移先に場所なしも表示するため、without_landmarkをつける
  return `${state.detection.detectionsLink}&without_landmark`;
});
const isJointDamage = computed(() => {
  return state.detection.detectionKind === 'joint_damage';
});
const isHosouDamage = computed(() => {
  return !isJointDamage.value;
});

const openDetection = () => {
  window.open(detectionsLink.value, '_blank');
};
const doAreaMovieSearch = () => {
  emit('area-movie-search', {
    lat: props.elem.data.location.lat,
    lon: props.elem.data.location.lon,
    radius: 500,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "col-icon" }, [
      _createElementVNode("img", {
        class: "resource-icon",
        src: iconPath
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ib lbl" }, "日時: ", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(dateDisp.value), 1),
            _createElementVNode("button", {
              type: "button",
              key: "msearch",
              class: "btn btn-sm btn-secondary ml12",
              onClick: doAreaMovieSearch
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-search mr2" }, null, -1),
              _createTextVNode("周辺の動画を検索 ", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, " 場所: " + _toDisplayString(kpDisp.value), 1),
            _withDirectives(_createElementVNode("span", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, "方角: " + _toDisplayString(state.detection.angle) + "°", 1),
              _createElementVNode("div", _hoisted_11, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "angle-arrow-bg" }, null, -1)),
                _createElementVNode("div", {
                  class: "angle-arrow-img",
                  style: _normalizeStyle({ transform: `rotateZ(${state.detection.angle}deg)`})
                }, null, 4)
              ])
            ], 512), [
              [_vShow, hasValidAngle.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ib lbl" }, "種別: ", -1)),
            _createElementVNode("span", _hoisted_13, _toDisplayString(state.detection.detectionKindDisp), 1),
            (isHosouDamage.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ib lbl ml12" }, "閾値: ", -1)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(state.detection.contourAreaMax), 1)
                ], 64))
              : _createCommentVNode("", true),
            (isJointDamage.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ib lbl ml12" }, "ジョイント種別: ", -1)),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(state.detection.jointTypesDisp), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (state.detection.comment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(state.detection.commentDisp), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            (_unref(savedImage))
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("img", {
                    src: _unref(savedImage),
                    class: "image",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showImage) && _unref(showImage)(...args)))
                  }, null, 8, _hoisted_20)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-xs mr4",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(showPrevious) && _unref(showPrevious)(...args)))
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
              _createTextVNode(" 前へ ", -1)
            ]))]),
            _createElementVNode("button", {
              class: "btn btn-primary btn-xs",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(showNext) && _unref(showNext)(...args)))
            }, [...(_cache[10] || (_cache[10] = [
              _createTextVNode(" 次へ ", -1),
              _createElementVNode("i", { class: "fas fa-arrow-right" }, null, -1)
            ]))])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "left-side" }, null, -1)),
        (!!state.detection.detectionsLink)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-info",
                onClick: openDetection
              }, " AI検知結果を開く ")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})